import { useState } from "react"
import { Link, NavLink } from "react-router-dom"

import styles from "./TestNav.module.css"
import logo from "../../assets/logo.png"
import iconLink from "../../assets/iconLink.svg"
import menuOpen from "../../assets/mobileBars.svg"
import menuClose from "../../assets/mobileCloseWhite.svg"

function getLinkStyle({ isActive }) {
	return {
		backgroundColor: isActive ? "rgba(255, 255, 255, 0.1)" : undefined,
		opacity: isActive ? "1" : undefined,
	}
}

function TestNav() {

	const [isOpen, setNav] = useState(false)
	const toggleNav = () => {
		setNav((isOpen) => !isOpen)
	}

	return (
		<>
			<div className={styles.testNav}>
				<div className={styles.logo}>
					<Link to="/">
						<img src={logo} alt="로고" />
					</Link>
				</div>
				<ul className={styles.menu}>
					<li>
						<h2>인증코드 검사 실시</h2>
						<div className={styles.subMenu}>
							<span>
								<NavLink to="/personal-code" style={getLinkStyle}>
									개인검사 인증코드
								</NavLink>
							</span>
							<span>
								<NavLink to="/group-code" style={getLinkStyle}>
									단체검사 인증코드
								</NavLink>
							</span>
						</div>
					</li>
					<li>
						<h2>웹 검사 실시</h2>
						<div className={styles.subMenu}>
							<span>
								<Link to="/start-test">온라인 검사</Link>
							</span>
						</div>
					</li>
					<li>
						<h2>검사 결과</h2>
						<div className={styles.subMenu}>
							<span>
								<NavLink to="/personal-result" style={getLinkStyle}>
									개인검사 결과보기
								</NavLink>
							</span>
							<span>
								<NavLink to="/group-result" style={getLinkStyle}>
									단체검사 결과보기
								</NavLink>
							</span>
						</div>
					</li>
				</ul>
				<div className={styles.homeBtn}>
					<Link to="https://humancollege.co.kr" target="_blank">
						<img src={iconLink} alt="인컬리지 홈페이지 바로가기" />
						인컬리지 홈페이지
					</Link>
				</div>
			</div>
			<div className={styles.moTWrap}>
				<div className={styles.moHeader}>
					<Link to="/">
						<img className={styles.logo} src={logo} alt="로고" />
					</Link>
					<div className={styles.menuOpen} onClick={toggleNav}>
						<img src={menuOpen} alt="메뉴 열기" />
					</div>
				</div>
				<div  className={isOpen ? `${styles.moTNav} ${styles.active}` : `${styles.moTNav}`}>
					<div className={styles.bg}></div>
					<div className={styles.menuWrap}>
						<div className={styles.header}>
							<div className={styles.menuClose} onClick={toggleNav}>
								<img src={menuClose} alt="메뉴 닫기" />
							</div>
						</div>
						<ul className={styles.moMenu}>
							<li>
								<h2>인증코드 검사 실시</h2>
								<div className={styles.subMenu}>
									<span>
										<NavLink to="/personal-code" style={getLinkStyle}>
											개인검사 인증코드
										</NavLink>
									</span>
									<span>
										<NavLink to="/group-code" style={getLinkStyle}>
											단체검사 인증코드
										</NavLink>
									</span>
								</div>
							</li>
							<li>
								<h2>웹 검사 실시</h2>
								<div className={styles.subMenu}>
									<span>
										<Link to="/start-test">온라인 검사</Link>
									</span>
								</div>
							</li>
							<li>
								<h2>검사 결과</h2>
								<div className={styles.subMenu}>
									<span>
										<NavLink to="/personal-result" style={getLinkStyle}>
											개인검사 결과보기
										</NavLink>
									</span>
									<span>
										<NavLink to="/group-result" style={getLinkStyle}>
											단체검사 결과보기
										</NavLink>
									</span>
								</div>
							</li>
						</ul>
						<div className={styles.homeBtn}>
							<Link to="https://humancollege.co.kr" target="_blank">
								<img src={iconLink} alt="인컬리지 홈페이지 바로가기" />
								인컬리지 홈페이지
							</Link>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default TestNav
